<template>
  <a :href="getUrl()" :key="partner.id">
    <div
      class="flex flex-col w-full h-full overflow-hidden bg-white rounded-xl"
    >
      <div
        class="w-full h-52 pt-3/4 md:pt-2/3"
        :style="`background-image: url('${partner.avatar}'); background-position: center; background-repeat: no-repeat; background-size: cover;`"
      ></div>

      <div class="flex flex-col justify-between flex-1 p-4">
        <div>
          <p class="mb-2 text-xs leading-none uppercase font-semimedium">
            {{ partner_type.title }}
          </p>

          <p class="font-normal">{{ partner.title }}</p>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
    partner_type: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getUrl() {
      let path = window.location;
      return `${path}/${this.partner.slug}`;
    },
  },
};
</script>
